export const joinPath = (directory: string, name: string) => {
  return directory === "/" ? directory + name : `${directory}/${name}`;
};
